import React from 'react';
import { useSelector } from 'react-redux';
import { Panel, Button } from 'govuk-react-jsx';
import useGaEndEvent from '../../hooks/useGaEndEvent';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import useTitle from '../../hooks/useTitle';
import { useSetReduxState } from '../../hooks/useResetReduxState';

const AccountCreated = () => {
  const [setResetReduxState] = useSetReduxState();
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;

  useGaEndEvent('LandlordRegistration', 'reg_account_created');
  useTitle(
    'landlordReg.AccountCreated.s16',
    'Account created - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );

  const handleBtnClick = () => {
    setResetReduxState('registrationJourney');
    window.location.assign('/signin');
  };

  return (
    <>
      <Panel
        titleChildren={copyProvider.getCopy(
          'landlordReg.AccountCreated.s15',
          'Account created'
        )}
      />

      <p className="govuk-body">
        {copyProvider.getCopy(
          'landlordReg.AccountCreated.s1',
          'We have sent you an email to confirm your account has been created.'
        )}
      </p>
      <h2 className="govuk-heading-m">
        {copyProvider.getCopy(
          'landlordReg.AccountCreated.s2',
          'What happens next'
        )}
      </h2>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'landlordReg.AccountCreated.s3',
          'Use your email and password to sign in to your acount and apply for the grant.'
        )}
      </p>
      <h2 className="govuk-heading-m">
        {copyProvider.getCopy(
          'landlordReg.AccountCreated.s4',
          'Before you apply'
        )}
      </h2>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'landlordReg.AccountCreated.s5',
          'You need to engage with an installer before you begin your application:'
        )}
      </p>
      <ul className="govuk-list govuk-list--bullet">
        <li>
          {copyProvider.getCopy(
            'landlordReg.AccountCreated.s6',
            'check that your installer is on the '
          )}
          <a
            href="https://www.gov.uk/guidance/evhs-and-wcs-become-an-authorised-installer#approved-installer-list"
            target="_blank"
            rel="noreferrer"
          >
            {copyProvider.getCopy(
              'landlordReg.AccountCreated.s7',
              'OZEV authorised installer list (opens in new tab)'
            )}
          </a>
        </li>
        <li>
          {copyProvider.getCopy(
            'landlordReg.AccountCreated.s8',
            'ensure that any chargepoint models installed are from the '
          )}
          <a
            href="https://www.gov.uk/government/publications/electric-vehicle-homecharge-scheme-approved-chargepoint-model-list"
            target="_blank"
            rel="noreferrer"
          >
            {copyProvider.getCopy(
              'landlordReg.AccountCreated.s9',
              'OZEV approved chargepoint model list (opens in new tab)'
            )}
          </a>
        </li>
      </ul>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'landlordReg.AccountCreated.s10',
          'Only OZEV authorised installers and OZEV chargepoint models are covered by this grant.'
        )}
      </p>
      <Button
        className="govuk-button govuk-!-margin-top-3"
        onClick={handleBtnClick}
      >
        {copyProvider.getCopy(
          'landlordReg.AccountCreated.s11',
          'Sign in to your account'
        )}
      </Button>
      <h2 className="govuk-heading-m">
        {copyProvider.getCopy(
          'landlordReg.AccountCreated.s12',
          'Help to make this service better'
        )}
      </h2>

      <p className="govuk-body">
        <a
          className="govuk-link"
          href="https://www.smartsurvey.co.uk/s/EV-grants/"
        >
          {copyProvider.getCopy(
            'landlordReg.AccountCreated.s13',
            'What did you think of this service? '
          )}
        </a>
        {copyProvider.getCopy(
          'landlordReg.AccountCreated.s14',
          ' (takes 30 seconds)'
        )}
      </p>
    </>
  );
};

export default AccountCreated;
